import { render } from "./EventDetailState.vue?vue&type=template&id=6cc28e49&scoped=true"
import script from "./EventDetailState.vue?vue&type=script&lang=js"
export * from "./EventDetailState.vue?vue&type=script&lang=js"

import "./EventDetailState.vue?vue&type=style&index=0&id=6cc28e49&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc28e49"]])

export default __exports__